import * as React from 'react';

import { EAreaPartsField } from '../../enums';

import { AreaPartInput } from '../AreaPartInput/AreaPartInput';

import { Field } from './internal/components/Field';
import { Price } from './internal/components/Price';

import { AreaPartProps } from './types';

import styles from './AreaPart.css';
import { Floor } from './internal/components/Floor/Floor';
import { ArticleHeading4, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';
import cn from 'classnames';
import { Photo } from './internal/components/Photo/Photo';
import { AreaPartItem } from './internal/components/AreaPartItem/AreaPartItem';

const AreaPartInner: React.FC<AreaPartProps> = props => {
  const {
    areaPart,
    id,
    invalidFields,
    isSale,
    onChangeField,
    onValidate,
    onPhotoSelect,
    onPhotoRemove,
    onPhotoRotate,
    uploadErrors,
  } = props;

  const { area, price, floorFrom, floorTo, photos } = areaPart;

  const isMobile = useDeviceType() === 'phone';

  return (
    <>
      <AreaPartItem isMobile={isMobile} isEmpty={!area} title="Площадь">
        <Field invalidFields={invalidFields} name={EAreaPartsField.Area} onValidate={onValidate}>
          <AreaPartInput
            id={id}
            name={EAreaPartsField.Area}
            value={area}
            maxWidth={92}
            minValue={1}
            onChange={onChangeField}
            dimensionTitle="м²"
            decimalDigits={2}
          />
        </Field>
      </AreaPartItem>

      <AreaPartItem isMobile={isMobile} isEmpty={floorFrom == null} title="Этаж">
        <Floor
          floorFrom={floorFrom}
          floorTo={floorTo}
          id={id}
          isMobile={isMobile}
          onChange={onChangeField}
          invalidFields={invalidFields}
          onValidate={onValidate}
        />
      </AreaPartItem>

      <AreaPartItem isMobile={isMobile} isEmpty={!price} title={isSale ? 'Цена' : 'Арендная плата'}>
        <Price
          {...areaPart}
          invalidFields={invalidFields}
          isSale={isSale}
          id={id}
          onChange={onChangeField}
          onValidate={onValidate}
        />
      </AreaPartItem>

      <div className={cn(styles['photo-container'], isMobile && styles['mobile'])}>
        <ArticleHeading4>Фотографии площади</ArticleHeading4>
        <br />
        <ArticleParagraph2>
          Добавьте реальные фотографии площади. Нельзя добавлять чужие фото, фото с&nbsp;водяными знаками
          и&nbsp;рекламные материалы. На&nbsp;фото не&nbsp;должно быть людей, животных, алкоголя, табака, оружия.
          <br />
          <br />
          Загрузите или перетащите сюда до 5 файлов JPG, PNG или GIF до 10 Мб каждый
        </ArticleParagraph2>

        <div className={styles['photo-container']}>
          <Photo
            error={uploadErrors.length ? uploadErrors.join('\r\n') : undefined}
            value={photos}
            handleFileRemove={onPhotoRemove}
            handleFileSelect={onPhotoSelect}
            handleFileRotate={onPhotoRotate}
            handleFilesMove={onChangeField}
          />
        </div>
      </div>
    </>
  );
};

export const AreaPart = React.memo(AreaPartInner);
